import React from 'react';
import { Auth } from 'aws-amplify';
import { ErrorMessage, Field, Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { useAlert } from 'react-alert';
import { createCookie } from '../../utils/cookies';
import { Input } from '../../components/Base/Elements';
import { AUTH_EXCEPTIONS } from '../../utils/verifyErrors';
import IconBack from "../../assets/icon/icon-back.svg";
import { BgSelectAppWebForm, LogoContainer } from "../../components/Base/styled";
import LogoAppWebSelectFarm from "../../assets/images/fundo-rosa-cima.png";
import { Button, ButtonActionBack, DivActionBack, Form, FormControl, H1, Title, ImgIconBack, InputError } from '../../assets/styles/GlobalStyles';
import { signUp } from '../../services/services';
import { translate } from '../../i18n/index';

const ConfirmSignUp = ({ history }) => {
  const alert = useAlert();
  const hasUsername = history.location.state ? history.location.state.username || '' : '';
  const hasPassword = history.location.state ? history.location.state.password || '' : '';

  function handleClickForgotPassword() {
    history.push({
      pathname: '/login',
      search: history.location.search,
    });
  }

  async function register() {
    try {
      await signUp();
      history.push({
        pathname: '/selecionar-fazenda',
        search: history.location.search,
      });
    } catch (e) {
      alert.show(translate('registerError'), {
        closeCopy: 'Fechar',
      });
    }
  }

  return (
    <>
      <DivActionBack>
        <ButtonActionBack onClick={() => handleClickForgotPassword()} type="button">
          <ImgIconBack src={IconBack} className="icon-back" alt="Button Back" />{translate('buttonActionBack')}
        </ButtonActionBack>
      </DivActionBack>
      <div>
        <LogoContainer
          style={{ alignSelf: 'center' }}
          rel="noopener noreferrer"
          target="_self">
          <BgSelectAppWebForm src={LogoAppWebSelectFarm} alt="Logo OnFarm" title="OnFarm" />
        </LogoContainer>
      </div>
      <Base width={430} marginTop="450" isAppWeb={true} backgroundForm={'#fff'}>
        <ContentContainer>
          <Formik
            enableReinitialize
            initialValues={{
              username: hasUsername,
              code: '',
            }}
            onSubmit={async (values, actions) => {
              if (values) {
                try {
                  await Auth.confirmSignUp(values.username.toLowerCase(), values.code);
                  alert.show(translate('confirmSignUpVerifiedUser'), {
                    closeCopy: 'Fechar',
                  });

                  if (hasPassword) {
                    const response = await Auth.signIn(values.username, hasPassword);
                    createCookie(response);
                    await register();
                  } else {
                    history.push({
                      pathname: '/',
                    });
                  }

                } catch (e) {
                  actions.setFieldValue('code', '');
                  if (e.message === AUTH_EXCEPTIONS.USER_ALREADY_CONFIRMED) {
                    alert.show(translate('confirmSignUpVerifiedAlreadyUser'), {
                      closeCopy: 'Fechar',
                      onClose: () => {
                        history.push({
                          pathname: '/',
                        });
                      },
                    });
                  }
                }
              }
              actions.setSubmitting(false);
            }}>
            {({ isSubmitting, handleChange }) => (
              <Form>
                <Title>
                  <H1>{translate('confirmSignUpWelcome')}</H1>
                  <H1>{translate('confirmSignUpTitle')}</H1>
                </Title>
                <FormControl>
                  <Field
                    type="username"
                    name="username"
                    onChange={handleChange}
                    placeholder={translate('inputLogin')}
                    component={Input}
                    disabled
                  />
                  <ErrorMessage name="username" component={InputError} />
                </FormControl>
                <FormControl>
                  <Field
                    type="code"
                    name="code"
                    onChange={handleChange}
                    placeholder={translate('inputCode')}
                    component={Input}
                  />
                  <ErrorMessage name="code" component={InputError} />
                </FormControl>
                <FormControl>
                  <Button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? translate('buttonSending') : translate('buttonSend')}
                  </Button>
                </FormControl>
              </Form>
            )}
          </Formik>
        </ContentContainer>
      </Base>
    </>
  );
};

export default ConfirmSignUp;
